export const environment = {
    production: true,
    // Portal hosts (sy.fixz.app and the other live sites) serve the SPA for /api.
    // The live API is on fixz.app, same host the mobile app and user site use.
    apiBaseUrl: 'https://fixz.app/api',
    domain: typeof window !== 'undefined' ? window.location.origin : 'https://fixz.app',
    appVersion: '1.0.0',
};
